/* eslint react/prop-types: 0 */
/* eslint no-console: 0 */

import React from 'react';
import _ from 'lodash';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

class InputPlacesAutocomplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = { address: '', firstTime: true };
    this.onChange = address => this.setState({ address, firstTime: false });
  }

  handleFormSubmit = event => {
    event.preventDefault();

    geocodeByAddress(this.state.address)
      .then(results => getLatLng(results[0]))
      .then(latLng => console.log('Success', latLng))
      .catch(error => console.error('Error', error));
  };

  render() {
    const inputProps = {
      id: 'direccion',
      value:
        _.isEmpty(this.state.address) && this.state.firstTime
          ? this.props.direccion
          : this.state.address,
      placeholder: '',
      onChange: this.onChange,
    };

    const cssClasses = {
      root: 'form-group',
      input: 'form-control',
      autocompleteContainer: 'my-autocomplete-container',
    };

    return (
      <form onSubmit={this.handleFormSubmit}>
        <PlacesAutocomplete inputProps={inputProps} classNames={cssClasses} />
      </form>
    );
  }
}
export default InputPlacesAutocomplete;



// WEBPACK FOOTER //
// ./src/components/FormComponents/InputPlacesAutocomplete/InputPlacesAutocomplete.js